
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { CourseService } from 'src/app/services/http/business/course/course.service';

@Component({
  selector: 'app-course-sessions',
  templateUrl: './course-sessions.component.html',
  styleUrls: ['./course-sessions.component.css']
})
export class CourseSessionsComponent implements OnInit {
  Sessions = [];


  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    "sessionDatePersian",
    "sessionTime",
    "status",
    "function"
  ];
  paginator: any;
  constructor(
    private courseService: CourseService,
    private dialog: MatDialogRef<CourseSessionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.getCourseSession();
  }

  getCourseSession() {
   
    this.dataSource = null;
    this.courseService.getCourseSessionNotPresent(this.data.Id).subscribe(result => {
     
      this.dataSource = result;
      //this.paginator.length = result;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    })
  }

  sessionSelected(data: any) {
    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }

}
